// extracted by mini-css-extract-plugin
export var change = "_3y-1";
export var changeList = "_3y-0";
export var changePath = "_3y-2";
export var diffArrow = "_3y-5";
export var diffRow = "_3y-3";
export var diffValue = "_3y-4";
export var error = "_3y-8";
export var notice = "_3y-9";
export var result = "_3y-6";
export var success = "_3y-7";